import { Button, IconButton, Stack } from '@mui/material';
import { DeleteOutline, PencilOutline, Paperclip, ClipboardTextClockOutline } from 'mdi-material-ui';
import { DataGridAction, DefaultActions, NewColumn } from '../datagrid-types';
import RowActions from '../components/RowActions';
import { Fragment, MutableRefObject } from 'react';
import { VigoTooltip } from 'src/@vigo/vigo-tooltip';
import { DataGridRef } from 'devextreme-react/data-grid';
import { setSelectedEntityId } from 'src/store/slices/attachmentsDataSlice';

const evaluateDisabledRow = (row: any, code: string | undefined): boolean => {
  return Boolean(eval(code != undefined ? code : ''));
};

function getWidth(actions: any, defaultActions?: DefaultActions) {
  let actionwidth = actions.length < 1 ? 0 : 35;

  actions.forEach((element: { alwaysShow: any }) => {
    if (element.alwaysShow) {
      actionwidth = actionwidth + 40;
    }
  });

  let width = actionwidth;
  if (defaultActions?.canDelete) {
    width = width + 40;
  }
  if (defaultActions?.canEdit) {
    width = width + 40;
  }
  if (defaultActions?.canNavigate) {
    width = width + 40;
  }

  if (defaultActions?.showHistory) {
    width = width + 40;
  }

  if (defaultActions?.showAttachments) {
    width = width + 40;
  }
  if (defaultActions?.canDelete) {
    width = width + 40;
  }

  if (width < 80) {
    width = 80;
  }

  return width;
}

export const defaultColumns = (
  actions: DataGridAction[],
  uiFlowDispatch: any,
  defaultActions?: DefaultActions,
  hideActions?: boolean,
  gridRef?: MutableRefObject<DataGridRef<any, any> | null>
): NewColumn[] => {
  if (hideActions) {
    return [];
  } else {
    return [
      {
        alignment: 'center',
        caption: 'Actions',
        dataField: '',
        fixed: true,
        allowSearch: false,
        allowFiltering: false,
        minWidth: getWidth(actions, defaultActions) + 10,
        cellRender: ({ data: row, rowIndex, row: { isEditing } }) => (
          <>
            {isEditing && (
              <Stack direction="row" justifyContent="center">
                <Button onClick={() => gridRef?.current?.instance()?.saveEditData()}>Save</Button>
                <Button onClick={() => gridRef?.current?.instance()?.cancelEditData()}>Cancel</Button>
              </Stack>
            )}

            {!isEditing && (
              <div>
                {defaultActions && defaultActions.canEdit && (
                  <>
                    <VigoTooltip title={'Edit'}>
                      <IconButton
                        sx={{ '&:hover': { color: theme => theme.palette.customColors.primaryGradient } }}
                        onClick={e => {
                          e.stopPropagation();
                          if (defaultActions != undefined && defaultActions.editCallBack != undefined) {
                            defaultActions.editCallBack(row.id, row.isDeleted);
                          }
                        }}>
                        <PencilOutline fontSize="medium" />
                      </IconButton>
                    </VigoTooltip>
                  </>
                )}
                {defaultActions && defaultActions.canDelete && (
                  <>
                    <VigoTooltip title={'Delete'}>
                      <IconButton
                        sx={{ '&:hover': { color: theme => theme.palette.customColors.primaryGradient } }}
                        onClick={e => {
                          e.stopPropagation();
                          if (defaultActions != undefined && defaultActions.deleteCallBack != undefined) {
                            defaultActions.deleteCallBack(row.id, row?.version ?? '', row.isDeleted);
                          }
                        }}>
                        <DeleteOutline fontSize="medium" />
                      </IconButton>
                    </VigoTooltip>
                  </>
                )}
                {defaultActions && defaultActions.showAttachments && (
                  <>
                    <VigoTooltip title={'Attactments'}>
                      <IconButton
                        sx={{ '&:hover': { color: theme => theme.palette.customColors.primaryGradient } }}
                        onClick={e => {
                          e.stopPropagation();
                          //console.log('implement attachements');
                        }}>
                        <Paperclip fontSize="medium" />
                      </IconButton>
                    </VigoTooltip>
                  </>
                )}
                {defaultActions && defaultActions.showHistory && (
                  <>
                    <VigoTooltip title={'History'}>
                      <IconButton
                        sx={{ '&:hover': { color: theme => theme.palette.customColors.primaryGradient } }}
                        onClick={e => {
                          e.stopPropagation();
                          if (defaultActions != undefined && defaultActions.showHistoryCallBack != undefined) {
                            defaultActions.showHistoryCallBack(row.id, row.ownerPartnerId);
                          }
                        }}>
                        <ClipboardTextClockOutline fontSize="medium" />
                      </IconButton>
                    </VigoTooltip>
                  </>
                )}
                {actions
                  .filter(action => action.alwaysShow)
                  .map(action => (
                    <Fragment key={action.id}>
                      <VigoTooltip title={action.dynamicText !== undefined ? action.dynamicText?.(row) : action.text}>
                        <span>
                          <IconButton
                            id={'actionButton' + action.id}
                            key={action.id}
                            sx={{ ':disabled': 'color: rgba(51, 51, 51, 0.1)', ...(action?.sx ?? {}) }}
                            disabled={action.disableCallback != null && action.disableCallback(row)}
                            onClick={e => {
                              {
                                e.stopPropagation();
                                uiFlowDispatch(setSelectedEntityId((row.id as string) ?? ''));
                                evaluateDisabledRow(row, 'true');
                                if (action.clickHandler != undefined) {
                                  action.clickHandler(row, action.text);
                                }
                              }
                            }}>
                            {action.icon}
                          </IconButton>
                        </span>
                      </VigoTooltip>
                    </Fragment>
                  ))}
                {actions.length > 0 && (
                  <RowActions
                    row={row}
                    actions={actions}
                    defaultActions={defaultActions}
                    rowIndex={rowIndex}
                    gridRef={gridRef}
                  />
                )}
              </div>
            )}
          </>
        )
      }
    ];
  }
};
